{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "no-show": "No-show",
      "checked-in": "Checked in"
    },
    "resultStatus": {
      "final": "Final",
      "preliminary": "Preliminary",
      "corrected": "Corrected"
    },
    "allergySeverity": {
      "severe": "Severe",
      "high": "High",
      "moderate": "Moderate"
    },
    "nationalIdType": {
      "NRIC": "NRIC (Singapore)",
      "HKID": "HKID (Hong Kong)",
      "MyKad": "MyKad (Malaysia)",
      "Aadhaar": "Aadhaar (India)",
      "KTP": "KTP (Indonesia)",
      "Passport": "Passport"
    },
    "messageSenderType": {
      "provider": "Provider",
      "patient": "Patient"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "Passwords do not match",
      "passwordMinLength": "Password must be at least 8 characters"
    }
  },
  "labels": {
    "abnormal": "Abnormal"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "My Health",
        "results": "Results",
        "appointments": "Appointments",
        "messages": "Messages",
        "forms": "Forms"
      },
      "signOut": "Sign out",
      "signOutAria": "Sign out",
      "navAria": "Portal navigation",
      "footer": "VynaEMR Patient Portal — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "Patient Portal",
      "labels": {
        "email": "Email",
        "password": "Password"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "Enter your password"
      },
      "button": {
        "signIn": "Sign In",
        "signingIn": "Signing in..."
      },
      "toast": {
        "welcome": "Welcome back!",
        "invalid": "Invalid email or password"
      },
      "links": {
        "noAccount": "Don't have an account?",
        "register": "Register"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "Good morning",
        "afternoon": "Good afternoon",
        "evening": "Good evening",
        "fallbackName": "there"
      },
      "subtitle": "Here is your health summary.",
      "error": "Unable to load your health summary. Please try again later.",
      "demographics": {
        "ageLabel": "Age {{age}}",
        "bloodTypeLabel": "Blood type: {{bloodType}}"
      },
      "quickLinks": {
        "results": "Results",
        "appointments": "Appointments",
        "messages": "Messages",
        "forms": "Forms"
      },
      "sections": {
        "allergies": "Allergies",
        "activeMedications": "Active Medications",
        "activeProblems": "Active Problems",
        "upcomingAppointments": "Upcoming Appointments",
        "recentResults": "Recent Results",
        "immunizations": "Immunisations",
        "emergencyContact": "Emergency Contact"
      },
      "states": {
        "noAllergies": "No known allergies on file.",
        "noMedications": "No active medications.",
        "noAppointments": "No upcoming appointments.",
        "noResults": "No recent results."
      },
      "moreCount": "+{{count}} more",
      "sinceDate": "since {{date}}",
      "doseNumber": "Dose {{number}}",
      "viewAll": "View all",
      "providerTBD": "Provider TBD"
    },
    "register": {
      "subtitle": "Create your account",
      "labels": {
        "fullName": "Full Name",
        "email": "Email",
        "dateOfBirth": "Date of Birth",
        "phone": "Phone",
        "mrn": "MRN (Medical Record Number)",
        "idType": "ID Type",
        "idNumber": "ID Number",
        "password": "Password",
        "confirmPassword": "Confirm Password"
      },
      "placeholders": {
        "fullName": "Your full name",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "Your ID number",
        "password": "At least 8 characters",
        "confirmPassword": "Re-enter your password",
        "selectIdType": "Select..."
      },
      "mrnHint": "To link your account to your medical record, provide your MRN or National ID.",
      "button": {
        "createAccount": "Create Account",
        "creatingAccount": "Creating account..."
      },
      "toast": {
        "success": "Registration successful. Please sign in.",
        "failure": "Registration failed. Please try again."
      },
      "links": {
        "haveAccount": "Already have an account?",
        "signIn": "Sign in"
      },
      "aria": {
        "dateOfBirth": "Date of Birth"
      }
    },
    "appointments": {
      "title": "Appointments",
      "subtitle": "View and manage your appointments",
      "error": "Unable to load appointments. Please try again later.",
      "sections": {
        "upcoming": "Upcoming",
        "past": "Past"
      },
      "states": {
        "noUpcoming": "No upcoming appointments.",
        "noPast": "No past appointments."
      },
      "reasonLabel": "Reason: {{reason}}",
      "instructionsLabel": "Instructions: {{instructions}}",
      "durationMinutes": "{{minutes}} min",
      "actions": {
        "cancel": "Cancel",
        "confirmCancel": "Confirm",
        "cancelling": "Cancelling...",
        "keep": "Keep"
      },
      "toast": {
        "cancelSubmitted": "Cancellation request submitted. Your care team will confirm.",
        "cancelFailed": "Failed to cancel appointment. Please call the office."
      }
    },
    "results": {
      "title": "My Results",
      "subtitle": "View your lab and imaging results",
      "error": "Unable to load results. Please try again later.",
      "referenceRange": "(Ref: {{range}})",
      "states": {
        "noResults": "No results available."
      }
    },
    "messages": {
      "title": "Messages",
      "subtitle": "Communicate with your care team",
      "error": "Unable to load messages. Please try again later.",
      "fromSender": "from {{name}}",
      "labels": {
        "subject": "Subject",
        "message": "Message",
        "reply": "Reply"
      },
      "placeholders": {
        "subject": "Message subject",
        "message": "Type your message...",
        "reply": "Type your reply..."
      },
      "actions": {
        "newMessage": "New Message",
        "back": "Back to messages",
        "sendMessage": "Send Message",
        "sendReply": "Send Reply",
        "sending": "Sending..."
      },
      "states": {
        "noMessages": "No messages yet."
      },
      "thread": {
        "fromSenderWithType": "From {{name}} ({{type}})"
      },
      "compose": {
        "title": "New Message",
        "subtitle": "Your message will be sent to your care team."
      },
      "toast": {
        "sent": "Message sent",
        "sendFailed": "Failed to send message"
      }
    },
    "forms": {
      "title": "Forms",
      "subtitle": "Complete required forms and questionnaires",
      "error": "Unable to load forms. Please try again later.",
      "sections": {
        "pending": "Pending",
        "completed": "Completed"
      },
      "labels": {
        "required": "Required"
      },
      "placeholders": {
        "select": "Select..."
      },
      "actions": {
        "fillOut": "Fill out",
        "back": "Back to forms",
        "submit": "Submit Form",
        "submitting": "Submitting..."
      },
      "states": {
        "noPending": "No pending forms.",
        "noCompleted": "No completed forms.",
        "noFields": "This form has no fields to fill out."
      },
      "toast": {
        "submitted": "Form submitted successfully",
        "submitFailed": "Failed to submit form"
      }
    }
  }
}
